import { createAsyncAction, createAction } from "typesafe-actions";
import {
  CommentTooltip,
  FetchedHighlights,
  Filter,
  Highlight,
  Language,
  SelectionId,
  Tooltip,
} from "./types";

export const fetchHighlights = createAsyncAction(
  "HIGHLIGHTING/LIST/REQUEST",
  "HIGHLIGHTING/LIST/SUCCESS",
  "HIGHLIGHTING/LIST/FAILURE",
)<
  { filter: Filter },
  {
    data: FetchedHighlights;
  },
  never
>();

export const createHighlight = createAsyncAction(
  "HIGHLIGHTING/CREATE/REQUEST",
  "HIGHLIGHTING/CREATE/SUCCESS",
  "HIGHLIGHTING/CREATE/FAILURE",
)<Highlight, { data: Highlight }, never>();

export const updateHighlight = createAsyncAction(
  "HIGHLIGHTING/UPDATE/REQUEST",
  "HIGHLIGHTING/UPDATE/SUCCESS",
  "HIGHLIGHTING/UPDATE/FAILURE",
)<Highlight, { data: Highlight }, never>();

export const removeHighlight = createAsyncAction(
  "HIGHLIGHTING/REMOVE/REQUEST",
  "HIGHLIGHTING/REMOVE/SUCCESS",
  "HIGHLIGHTING/REMOVE/FAILURE",
)<Highlight, string | number | undefined, never>();

export const initHighlighting = createAction("HIGHLIGHTING/INITIALIZE")<{
  filter: Filter;
  lang?: Language;
}>();

export const initSelections = createAction("HIGHLIGHTING/INIT_SELECTIONS")();

export const setSelections = createAction("HIGHLIGHTING/SET_SELECTIONS")<
  Highlight[]
>();

export const setTooltipData = createAction(
  "HIGHLIGHTING/SET_TOOLTIP_DATA",
)<Tooltip>();

export const setCommentTooltipData = createAction(
  "HIGHLIGHTING/SET_COMMENT_TOOLTIP_DATA",
)<CommentTooltip>();

export const handleMouseUp = createAction("HIGHLIGHTING/HANDLE_MOUSE_UP")<{
  left: number;
  top: number;
}>();

export const handleMouseDown = createAction("HIGHLIGHTING/HANDLE_MOUSE_DOWN")();

export const setActiveSelectionId = createAction(
  "HIGHLIGHTING/SET_ACTIVE_SELECTION_ID",
)<SelectionId>();

export const clearHighlights = createAction("HIGHLIGHTING/CLEAR")();

export const editComment = createAction(
  "HIGHLIGHTING/COMMENT_EDIT",
)<Highlight>();

export const showCommentTooltip = createAction(
  "HIGHLIGHTING/COMMENT_TOOLTIP_SHOW",
)();

export const hideCommentTooltip = createAction(
  "HIGHLIGHTING/COMMENT_TOOLTIP_HIDE",
)();

export const removeComment = createAction(
  "HIGHLIGHTING/COMMENT_REMOVE",
)<Highlight>();

export const updateActiveSelection = createAction(
  "HIGHLIGHTING/ACTIVE_SELECTION_UPDATE",
)<{ [key: string]: any }>();
